import { gql } from 'apollo-boost';
import { useMutation } from '../';

const query = gql`
  mutation newNpoIndicator(
    $id: Int
    $reportId: Int!
    $indicatorId: Int!
    $forecast: String
    $happensAfterProgramYear: String
    $timePeriod: String
    $measurement: String
    $file: String
  ) {
    newNpoIndicator(
      id: $id
      reportId: $reportId
      indicatorId: $indicatorId
      forecast: $forecast
      happensAfterProgramYear: $happensAfterProgramYear
      timePeriod: $timePeriod
      measurement: $measurement
      file: $file
    ) {
      success
      id
    }
  }
`;

export function useNewNpoIndicator() {
  const { data, isLoading, mutate } = useMutation();
  const run = (variables, onFinish) => {
    mutate(query, variables, response => {
      if (typeof onFinish === 'function') {
        onFinish(response.newNpoIndicator.id);
      }
    });
  };
  return { data, isLoading, run };
}
